import { PingCommand } from './PingCommand.js';
import { GetTCDataCommand } from './GetTCDataCommand.js';
import { GetInAppTCDataCommand } from './GetInAppTCDataCommand.js';
import { GetVendorListCommand } from './GetVendorListCommand.js';
import { AddEventListenerCommand } from './AddEventListenerCommand.js';
import { RemoveEventListenerCommand } from './RemoveEventListenerCommand.js';
import { TCFCommand } from './TCFCommand.js';
export class CommandMap {
    static [TCFCommand.PING] = PingCommand;
    static [TCFCommand.GET_TC_DATA] = GetTCDataCommand;
    static [TCFCommand.GET_IN_APP_TC_DATA] = GetInAppTCDataCommand;
    static [TCFCommand.GET_VENDOR_LIST] = GetVendorListCommand;
    static [TCFCommand.ADD_EVENT_LISTENER] = AddEventListenerCommand;
    static [TCFCommand.REMOVE_EVENT_LISTENER] = RemoveEventListenerCommand;
}
